// extracted by mini-css-extract-plugin
export default {"left":"Button_left__I2Epv","right":"Button_right__0bSWz","both":"Button_both__5VXBB"};